module.exports = __webpack_public_path__ + "img/logo-iremote.70ce23b5.png";